import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="score-select"
export default class extends Controller {
  apply(event) {
    const selectedValue = event.target.value
    const id = event.target.dataset.id
    const type = event.target.dataset.type

    get(`/ixly/assessments/${id}?type=${type}&norm_group=${selectedValue}`, {
      responseKind: "turbo-stream",
    })
  }
}
